import AxiosJob from '@/services/api/job/axios_job'

export default {
  createDeliverableSet: (data) => {
    return AxiosJob.post('deliverable-set', data)
  },

  updateDeliverableSet: (deliverableSetId, data) => {
    return AxiosJob.put(`deliverable-set/${deliverableSetId}`, data)
  },

  getAllDeliverableSets: (params) => {
     return AxiosJob.get('deliverable-set', { params })
  },

  getDeliverableSet: (deliverableSetId) => {
    return AxiosJob.get(`deliverable-set/${deliverableSetId}`)
  },

  deleteDeliverableSet: (deliverableSetId) => {
    return AxiosJob.delete(`deliverable-set/${deliverableSetId}`)
  }
}
